import { useQuery } from '@tanstack/react-query';

import agentApiClient from '../api/agentClient';
import { queryKeys } from '../api/queryKeys';

export const useTenants = () => {
  return useQuery({
    queryKey: queryKeys.tenants.all,
    queryFn: async () => {
      const result = await agentApiClient.listTenants();
      return Array.isArray(result) ? result : [];
    },
    staleTime: 5 * 60 * 1000,
  });
};

// Maps a tenant ID to its display name; falls back to the raw ID while the list loads or if unknown.
export const useTenantName = () => {
  const { data: tenants = [] } = useTenants();
  return (tenantId: string) =>
    tenants.find(tenant => tenant.id === tenantId)?.name ?? tenantId;
};
